import { Box, Button, Grid, Paper, Table, TableBody, TableCell, TableContainer, TableHead, TableRow, Typography } from "@mui/material";
import { Order, UpdateOrder } from "../../app/models/order";
import { currencyFormat } from "../../app/util/util";
import LoadingComponent from "../../app/layout/LoadingComponent";
import { useState } from "react";
import EditOrder from "./EditOrder";
import agent from "../../app/api/agent";
import { toast } from "react-toastify";

import { LoadingButton } from "@mui/lab";

interface Props {
    order: Order | undefined
    cancelDetail: () => void
    
}

export default function OrderDetails(props: Props) {
  const {order, cancelDetail} = props
  const [editMode, setEditMode] = useState(false)
  const [loading, setLoading] = useState(false)
  
  function cancelEdit() {
     setEditMode(false)
  }

  function sendEmail() {
      setLoading(true)
      let trackingInfo : UpdateOrder = {
        id: order?.id!,
        buyerEmail: order?.buyerEmail!,
        orderStatus: order?.orderStatus!,
        courierServiceProvider: order?.courierServiceProvider!,
        trackingNumber: order?.trackingNumber!,
        notes: order?.notes!
      }
      agent.Admin.sendEmailForTrackingOrder(trackingInfo)
      .then(() => {
        setLoading(false)
        toast.success('An email has been sent')  
      })
      .catch(error => console.log(error)) 
  }

  if (!order) return <LoadingComponent message="Loading order"/>
  
  
  return (
    <>
    <Box display='flex' justifyContent='space-between'>
        <Typography sx={{ p: 2 }} variant='h4'>Order #{order.id} Details</Typography>
    </Box>
    <Grid container spacing={4}>
      <Grid item xs={12} md={5}>
            <Typography sx={{ p: 2 }} variant='h5'>Buyer Info</Typography>
            <TableContainer component={Paper}>
              
              <Table aria-label="simple table">
                  <TableBody>
                          <TableRow
                              sx={{ '&:last-child td, &:last-child th': { border: 0 } }}
                          >
                              <TableCell>
                                  Buyer Id: 
                              </TableCell>
                              <TableCell align="left">
                              {order.buyerId}
                              </TableCell>  
                          </TableRow>
                          <TableRow
                              sx={{ '&:last-child td, &:last-child th': { border: 0 } }}
                          > 
                              <TableCell align="left">
                                  Buyer Email: 
                              </TableCell>
                              <TableCell align="left">
                                  {order.buyerEmail}
                              </TableCell> 
                          </TableRow>
                  </TableBody>
              </Table>
          </TableContainer>

          <Typography sx={{ p: 2 }} variant='h5'>Shipping Address</Typography>
              <TableContainer component={Paper} sx={{ mb: 2 }}>
                
                <Table aria-label="simple table">
                    <TableBody>
                            <TableRow
                                sx={{ '&:last-child td, &:last-child th': { border: 0 } }}
                            >
                                <TableCell>
                                    Full name: 
                                </TableCell>
                                <TableCell align="left">
                                {order.shippingAddress.fullName}
                                </TableCell>  
                            </TableRow>
                            <TableRow
                                sx={{ '&:last-child td, &:last-child th': { border: 0 } }}
                            > 
                                <TableCell align="left">
                                    Address 1: 
                                </TableCell>
                                <TableCell align="left">
                                    {order.shippingAddress.address1}
                                </TableCell> 
                            </TableRow>
                            <TableRow
                                sx={{ '&:last-child td, &:last-child th': { border: 0 } }}
                            > 
                                <TableCell align="left">
                                    Address 2: 
                                </TableCell>
                                <TableCell align="left">
                                    {order.shippingAddress.address2}
                                </TableCell> 
                            </TableRow>
                            <TableRow
                                sx={{ '&:last-child td, &:last-child th': { border: 0 } }}
                            > 
                                <TableCell align="left">
                                    City: 
                                </TableCell>
                                <TableCell align="left">
                                    {order.shippingAddress.city}
                                </TableCell> 
                            </TableRow>
                            <TableRow
                                sx={{ '&:last-child td, &:last-child th': { border: 0 } }}
                            > 
                                <TableCell align="left">
                                    Region: 
                                </TableCell>
                                <TableCell align="left">
                                    {order.shippingAddress.region}
                                </TableCell> 
                            </TableRow>
                            <TableRow
                                sx={{ '&:last-child td, &:last-child th': { border: 0 } }}
                            > 
                                <TableCell align="left">
                                    Post code: 
                                </TableCell>
                                <TableCell align="left">
                                    {order.shippingAddress.postCode}
                                </TableCell> 
                            </TableRow>
                            <TableRow
                                sx={{ '&:last-child td, &:last-child th': { border: 0 } }}
                            > 
                                <TableCell align="left">
                                    Country: 
                                </TableCell>
                                <TableCell align="left">
                                    {order.shippingAddress.country}
                                </TableCell> 
                            </TableRow>
                            <TableRow
                                sx={{ '&:last-child td, &:last-child th': { border: 0 } }}
                            > 
                                <TableCell align="left">
                                    Phone: 
                                </TableCell>
                                <TableCell align="left">
                                    {order.shippingAddress.phoneNumber}
                                </TableCell> 
                            </TableRow>
                            <TableRow
                                sx={{ '&:last-child td, &:last-child th': { border: 0 } }}
                            > 
                                <TableCell align="left">
                                    Shipping option: 
                                </TableCell>
                                <TableCell align="left">
                                    {order.shippingAddress.shippingOption}
                                </TableCell> 
                            </TableRow>
                    </TableBody>
                </Table>
            </TableContainer>
        </Grid>
        <Grid item xs={12} md={7}>
            <Typography sx={{ p: 2 }} variant='h5'>Ordered Items</Typography>
            <TableContainer component={Paper}>
              
                <Table aria-label="simple table">
                    <TableHead>
                        <TableRow>
                            <TableCell>#</TableCell>
                            <TableCell align="left">Product</TableCell>
                            <TableCell align="right">Price</TableCell>
                            <TableCell align="center">Quantity</TableCell>
                        </TableRow>
                    </TableHead>
                    <TableBody>
                        {order.orderItems.map((product) => (
                            <TableRow
                                key={product.productId}
                                sx={{ '&:last-child td, &:last-child th': { border: 0 } }}
                            >
                                <TableCell component="th" scope="row">
                                    {product.productId}
                                </TableCell>
                                <TableCell align="left">
                                    <Box display='flex' alignItems='center'>
                                        <img src={product.pictureUrl} alt={product.name} style={{ height: 50, marginRight: 20 }} />
                                        <span>{product.name}</span>
                                    </Box>
                                </TableCell>
                                <TableCell align="right">{currencyFormat(product.price)}</TableCell>
                               
                                
                                <TableCell align="center">{product.quantity}</TableCell>
                                
                            </TableRow>
                        ))}
                        </TableBody>
                    </Table>
                </TableContainer>
                
                <Typography sx={{ p: 2 }} variant='h5'>Summary</Typography>
                <TableContainer component={Paper} variant={'outlined'}>
                    <Table>
                        <TableBody>
                            <TableRow>
                                <TableCell colSpan={2}>Subtotal</TableCell>
                                <TableCell align="right">{currencyFormat(order.subtotal)}</TableCell>
                            </TableRow>
                            <TableRow>
                                <TableCell colSpan={2}>Delivery fee</TableCell>
                                <TableCell align="right">{currencyFormat(order.deliveryFee)}</TableCell>
                            </TableRow>
                            <TableRow>
                                <TableCell colSpan={2}>Total</TableCell>
                                <TableCell align="right">{currencyFormat(order.total)}</TableCell>
                            </TableRow>
                            
                        </TableBody>
                    </Table>
                </TableContainer>
            <Typography sx={{ p: 2 }} variant='h5'>Order management</Typography>
                <TableContainer component={Paper} variant={'outlined'} sx={{ mb: 2 }}>
                    <Table>
                        <TableBody>
                            
                            <TableRow>
                                <TableCell colSpan={2}>Order Status</TableCell>
                                <TableCell align="right">{order.orderStatus}</TableCell>
                            </TableRow>

                            <TableRow>
                                <TableCell colSpan={2}>Courier service provider</TableCell>
                                <TableCell align="right">{order.courierServiceProvider}</TableCell>
                            </TableRow>

                            <TableRow>
                                <TableCell colSpan={2}>Tracking number</TableCell>
                                <TableCell align="right">{order.trackingNumber}</TableCell>
                            </TableRow>
                            
                            <TableRow>
                                <TableCell colSpan={2}>Notes</TableCell>
                                <TableCell align="right">{order.notes}</TableCell>
                            </TableRow>
                           
                        </TableBody>
                    </Table>
                </TableContainer>
                {!editMode && 
                <>
                    <Button variant="contained" size='large' sx={{ mb: 2, mr: 4}} onClick={() => setEditMode(true)}>Edit</Button>
                    <Button variant="contained" size='large' sx={{mb: 2, bgcolor: 'primary.light'}} onClick={cancelDetail}>Back to lists</Button> 
                </>}
                {editMode && 
                <>
                    <EditOrder order={order} cancelEdit={cancelEdit} />
                    
                </>}

                {!editMode && order.trackingNumber !== null && order.trackingNumber !== 'None'  &&
                  <LoadingButton loading={loading} variant="contained" size='large' sx={{ mb: 2, mr: 4}} onClick={sendEmail}>Send an email to notify customer the order has been shipped</LoadingButton>

                }
                
            </Grid>

        </Grid>
    </>
  )
}